module.exports = __webpack_public_path__ + "31814a7586820d01b26782c5e7adc657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-21.jpg
// module id = 1162
// module chunks = 0